import {TimingsService} from "@vicman-wi/telemetry-js/esm/timings/TimingsService";
import {stringIsTrueValue} from "@vicman-wi/utils-js/esm/string/is-true-value";
import {stringToNumbers} from "@vicman-wi/utils-js/esm/string/to-numbers";
import logger from "./logger";

let instance = null;

/** @return {TimingsService} */
export function getTimingsService() {
  if (instance) return instance;

  const userGroups = stringToNumbers(process.env.REACT_APP_TIMINGS_USER_GROUPS);

  instance = new TimingsService(
    {
      isEnabled: stringIsTrueValue(process.env.REACT_APP_TIMINGS_ENABLED),
      isMuted: userGroups.indexOf(window.clientConfig.splitGroupId) === -1,
    },
    logger()
  );

  return instance;
};